import {
  create,
  get,
  type CredentialCreationOptionsJSON,
  type CredentialRequestOptionsJSON,
  type PublicKeyCredentialWithAttestationJSON,
  type PublicKeyCredentialWithAssertionJSON,
} from '@github/webauthn-json'
import type { Schemas } from '@/api/client'

// Бэк отдаёт PublicKeyCredential(Creation|Request)Options по W3C — это inner
// `publicKey`-объект ceremony (свободный bag в контракте). Inner-типы из
// @github/webauthn-json не экспортируются, берём их через индексацию
// экспортируемых wrapper-типов.
type CreationOptions = CredentialCreationOptionsJSON['publicKey']
type RequestOptions = NonNullable<CredentialRequestOptionsJSON['publicKey']>

// WebAuthn доступен только в secure-context с PublicKeyCredential — иначе passkey-UI прячем.
export function isPasskeySupported(): boolean {
  return typeof window !== 'undefined' && 'PublicKeyCredential' in window
}

// Регистрация: options от бэка → navigator.credentials.create через ponyfill →
// JSON-ответ браузера для отправки на сервер.
export function createCredential(
  options: Schemas['PublicKeyCredentialOptions'],
): Promise<PublicKeyCredentialWithAttestationJSON> {
  return create({ publicKey: options as unknown as CreationOptions })
}

// Аутентификация: options от бэка → navigator.credentials.get через ponyfill →
// JSON-assertion браузера.
export function getCredential(
  options: Schemas['PublicKeyCredentialOptions'],
): Promise<PublicKeyCredentialWithAssertionJSON> {
  return get({ publicKey: options as unknown as RequestOptions })
}
